import React, { useEffect, useState } from 'react';
import API from '../Api';
import SubPageHeader from '../../components/common/SubPageHeader';
// import SubPageFooter from '../../components/common/SubPageFooter';

// Assets Imports - 
import cart1 from '../../assets/images/Certificate-NR.jpeg'; 
import cart2 from '../../assets/images/certificate-45.jpeg';
import cart3 from '../../assets/images/Certificate-2.jpg';
import cart4 from '../../assets/images/Certificate-3.jpg';

const NationalAwards = () => {
  const [data, setData] = useState({});

  useEffect(() => {
    const fetchAwardsData = async () => {
      try {
        const res = await API.get('get-content/Awards/');
        setData(res.data);
      } catch (err) {
        console.error("Error loading awards data:", err);
      }
    };
    fetchAwardsData();
  }, []);

  const resolveImageUrl = (path, fallback) => {
    if (!path) return fallback;
    if (path.startsWith('http')) return path;
    const cleanPath = path.startsWith('/') ? path : `/media/${path}`;
    return `${process.env.REACT_APP_BACKEND_URL || 'http://103.172.92.148:8005'}${cleanPath}`;
  };

  const getEmbedUrl = (url) => {
    if (!url) return "https://www.youtube.com/embed/ZT_OnXNdYfg";
    if (url.includes('embed/')) return url;
    try {
      const videoId = url.split('v=')[1] || url.split('/').pop();
      return `https://www.youtube.com/embed/${videoId.split('&')[0]}`;
    } catch { return "https://www.youtube.com/embed/ZT_OnXNdYfg"; }
  };

  
  const defaultAwards = [
    { id: 1, title: "National Records Certificate", organization: "Global Records & Research Foundation", description: "Recognized for the globally deepest pool dive by the first PADI certified Father-Daughter duo.", image: cart1, badge: "Deepest Dive" },
    { id: 2, title: "India Book of Records", organization: "National Authorship Record", description: "Officially recorded for authoring a fascinating book on a scuba journey titled 'We Can! If U Will!!'.", image: cart2, badge: "National Author" },
    { id: 3, title: "World Record Achievement", organization: "Scuba Diving Excellence", description: "Honored for extraordinary performance in extreme underwater conditions as a family team.", image: cart3, badge: "World Record" },
    { id: 4, title: "PADI Certified Record", organization: "Professional Association of Diving Instructors", description: "Certified as the youngest Dad-Daughter duo from India to complete professional diving milestones.", image: cart4, badge: "Certified Duo" }
  ];

  
  const awards = [1, 2, 3, 4].map((i) => ({
    id: i,
    title: data[`award_${i}_title`] || defaultAwards[i-1].title,
    organization: data[`award_${i}_org`] || defaultAwards[i-1].organization,
    description: data[`award_${i}_desc`] || defaultAwards[i-1].description,
    badge: data[`award_${i}_badge`] || defaultAwards[i-1].badge,
    image: data[`award_${i}_img`] ? resolveImageUrl(data[`award_${i}_img`], defaultAwards[i-1].image) : defaultAwards[i-1].image
  }));

  
  // const awards = [
  //   {
  //     id: 1,
  //     title: "National Records Certificate",
  //     organization: "Global Records & Research Foundation",
  //     description: "Recognized for the globally deepest pool dive by the first PADI certified Father-Daughter duo.",
  //     image: cart1,
  //     badge: "Deepest Dive"
  //   },
  //   {
  //     id: 2,
  //     title: "India Book of Records",
  //     organization: "National Authorship Record",
  //     description: "Officially recorded for authoring a fascinating book on a scuba journey titled 'We Can! If U Will!!'.",
  //     image: cart2,
  //     badge: "National Author"
  //   },
  //   {
  //     id: 3,
  //     title: "World Record Achievement",
  //     organization: "Scuba Diving Excellence",
  //     description: "Honored for extraordinary performance in extreme underwater conditions as a family team.",
  //     image: cart3,
  //     badge: "World Record"
  //   },
  //   {
  //     id: 4,
  //     title: "PADI Certified Record",
  //     organization: "Professional Association of Diving Instructors",
  //     description: "Certified as the youngest Dad-Daughter duo from India to complete professional diving milestones.",
  //     image: cart4,
  //     badge: "Certified Duo"
  //   }
  // ];

  return (
    <div className="bg-gray-50 min-h-screen scroll-mt-30 mb-24 ">
        {/* className="relative min-h-[800px] flex items-stretch overflow-hidden mt-24 mb-24 lg:mt-32 lg:mb-32"> */}
      <SubPageHeader title="National Awards" subtitle="Recognizing Extraordinary Feats" />

      <div className="container mx-auto px-6 py-20">
        
        {/* 1. Certificate Gallery - 2 Cards per row */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-24">
          {awards.map((award) => (
            <div 
              key={award.id} 
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 flex flex-col md:flex-row"
            >
              {/* Certificate Image */}
              <div className="md:w-1/2 bg-gray-100 p-4 flex items-center justify-center">
                <img 
                  
                  src={`${award.image}?t=${new Date().getTime()}`} 
                  alt={award.title} 
                  className="max-h-64 w-auto object-contain shadow-md"
                />
              </div>

              {/* Info Content */}
              <div className="md:w-1/2 p-8 flex flex-col justify-center">
                <div className="inline-block bg-[#54a50f] text-white text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-tighter mb-4 w-fit">
                  {award.badge}
                </div>
                <h4 className="text-[#032167] font-bold text-xs uppercase tracking-widest mb-2 opacity-70">
                  {award.organization}
                </h4>
                <h3 className="text-xl font-bold text-gray-800 mb-3 leading-tight">
                  {award.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {award.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* 2. Video Section - Placed at the bottom */}
        <div className="bg-[#032167] rounded-3xl overflow-hidden shadow-2xl flex flex-col lg:flex-row items-center border-b-8 border-[#54a50f]">
          <div className="lg:w-1/2 p-10 lg:p-16 text-white text-center lg:text-left">
            <h2 className="text-3xl font-bold mb-6 uppercase tracking-wider">
              {data.video_title || "Dive in World's Deepest Pool"}
            </h2>
            <p className="text-lg opacity-80 leading-relaxed mb-8">
              {data.video_caption || "Mission 2022: Successfully dived with my buddy Owee in the world's deepest pool."}
            </p>
            <div className="flex justify-center lg:justify-start">
              <span className="border border-white/30 px-6 py-2 rounded-full text-sm font-medium">Featured Video</span>
            </div>
          </div>
          
          <div className="lg:w-1/2 w-full aspect-video">
            <iframe 
              className="w-full h-full"
              
              src={getEmbedUrl(data.youtube_link)} 
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
              title="YouTube Video"
            ></iframe>
          </div>
        </div>
        {/* Branding Quote */}
        <div className="mt-20 text-center">
          <p className="italic text-2xl text-[#032167] font-serif" style={{ fontFamily: "'Viner Hand ITC', cursive" }}>
            "Celebrating records that inspire happiness."
          </p>
        </div>
      </div>

      {/* <SubPageFooter /> */}
    </div>
  );
};

export default NationalAwards;